export const isItemLoadedStub = () => true;
